import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import router from './router';
import './index.css';
import './posthog'; // Initialize PostHog
import { initRouterAnalytics } from './router-analytics'; // Router analytics integration
import smoothscroll from 'smoothscroll-polyfill';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { CreditProvider } from './contexts/CreditContext';

smoothscroll.polyfill();

// Initialize router analytics to capture pageviews on navigation
initRouterAnalytics(router);

// TODO: Move client ID to config/env variable
const googleClientId = "977307211806-h4rn42vi8i2pkne78bt3uo2o3iak4i2f.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <AuthProvider>
        <CreditProvider>
          <RouterProvider router={router} />
        </CreditProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
